import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { SkillsShowcase } from "./subcomponents/SkillsShowcase";
import { motion } from "framer-motion";
import { backEnd, frontEnd, tools, envs } from "./ObjectFunctions/skillObjects";

export const Skills = () => {
	const [fe, setFe] = useState([]);
	const [be, setBe] = useState([]);
	const [to, setTo] = useState([]);
	const [env, setEnv] = useState([]);

	useEffect(() => {
		setFe(frontEnd);
		setBe(backEnd);
		setTo(tools);
		setEnv(envs);
	}, []);

	return (
		<Container id="widthRes" className="p-5">
			<motion.h1
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.5 }}
				className="text-light text-center m-auto p-3 mt-4 mb-5 border-bottom border-top rounded"
			>
				Skill Set
			</motion.h1>

			<motion.h1
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 1, delay: 0.5 }}
				className="text-light text-center mt-5"
			>
				FRONT END
			</motion.h1>

			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 1, delay: 0.5 }}
			>
				<SkillsShowcase items={fe} />
			</motion.div>

			<hr className="text-light"></hr>

			<motion.h1
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 1, delay: 1 }}
				className="text-light text-center mt-5"
			>
				BACK END
			</motion.h1>

			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 1, delay: 1 }}
			>
				<SkillsShowcase items={be} />
			</motion.div>

			<hr className="text-light"></hr>

			<motion.h1
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 1, delay: 1 }}
				className="text-light text-center mt-5"
			>
				DEV SERVICES
			</motion.h1>

			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 1, delay: 1 }}
			>
				<SkillsShowcase items={to} />
			</motion.div>
			<hr className="text-light"></hr>

			<motion.h1
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 1, delay: 1 }}
				className="text-light text-center mt-5"
			>
				TOOLS
			</motion.h1>

			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 1, delay: 1 }}
			>
				<SkillsShowcase items={env} />
			</motion.div>
		</Container>
	);
};
